import React, { Component } from "react";


class AboutHeaderSlide extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSlide: 0,
    };
    this.slides = [
      require("../../src/assets/images/website/about img2.png"),
      require("../../src/assets/images/website/about img1.png"),
      require("../../src/assets/images/website/about img3.png"),
      require("../../src/assets/images/website/about img4.png"),
      require("../../src/assets/images/website/about img5.png"),
    ];
  }
handleNextImage = () => {
  const nextSlide = (this.state.currentSlide + 1) % this.slides.length;

  this.setState({ currentSlide: -1 }, () => {
    setTimeout(() => {
      this.setState({ currentSlide: nextSlide });
    }, 50);
  });
};

  componentDidMount() {
    this.interval = setInterval(() => {
      this.setState((prevState) => ({
        currentSlide: (prevState.currentSlide + 1) % this.slides.length,
      }));
    }, 8000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    return (
      <div className="container-56">
        <div className="left-content-56">
          <h1 className="">KlinicQ Your Cloud-Based Solution for Streamlined Clinic Management & Enhanced Patient Care</h1>
          <p className="">
           Step into the future of healthcare with KlinicQ, a powerful cloud-based Electronic Clinical Management System (eCMS) designed to revolutionize your practice.
          </p>
            <div class="testimonial-card1">
                <div class="testimonial-avatars">
                    <img src={require("../../src/assets/images/website/img_ellipse_306.webp")} alt="" class="avatar" aria-hidden="true"/>
                    <img src={require("../../src/assets/images/website/img_ellipse_306.webp")} alt="" class="avatar" aria-hidden="true"/>
                    <img src={require("../../src/assets/images/website/img_ellipse_305.webp")} alt="" class="avatar" aria-hidden="true"/>
                    <img src={require("../../src/assets/images/website/img_ellipse_304.webp")} alt="" class="avatar" aria-hidden="true"/>
                </div>
                <div class="testimonial-divider"></div>
                {/* <img src={require("../../src/assets/images/website/img_32403354493a0fe7fe362882ff282f54_1.png")} alt="Google" class="google-icon" /> */}
                <img src={require("../../src/assets/images/website/support1.webp")} alt="Trusted healthcare software support and customer satisfaction" class="google-icon" />
                <div class="testimonial-content">
                    {/* <div class="testimonial-title">Take Our Support</div> */}
                     <div className="sliding-text-container5">
                      <div className="sliding-text5">
                        <span>Patient&nbsp;&nbsp;</span>
                        <span>Hospital&nbsp;&nbsp;</span>
                        <span>Doctor&nbsp;&nbsp;</span>
                      </div>
                    </div>
                    <img src={require("../../src/assets/images/website/img_group_8751.svg")} alt="Five star rating for KlinicQ healthcare management software" class="testimonial-stars" />
                </div>
                
                <a class="demo-button1" href="/contact" aria-label="Play demo video">
                <img src={require("../../src/assets/images/website/img_frame.svg")} alt="" class="demo-icon" aria-hidden="true"/>
            </a>
            </div>
          
        <button className="arrow-btn" onClick={this.handleNextImage}>
            <img src={require("../../src/assets/images/website/about arrow.png")} alt="Next KlinicQ feature slide" />
          </button>
        </div>
        <div className="right-content-56">
          <div className="carousel-56">
            {this.slides.map((src, index) => (
              <img
                key={index}
                src={src}
                alt="KlinicQ clinic management software interface and healthcare features"
                className={`carousel-img ${index === this.state.currentSlide ? "active" : ""}`}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default AboutHeaderSlide;
